import { gql } from 'graphql-request';
import {
  LifestyleAuthorID,
  LifestyleAuthorLocalizedName,
  LifestyleBlocked,
  LifestyleCategoryLocalizedName,
  LifestyleCategoryName,
  LifestyleCategoryUUID,
  LifestyleCreatedAt,
  LifestyleFavorite,
  LifestyleID,
  LifestyleImageFile,
  LifestyleImageID,
  LifestyleImageUUID,
  LifestyleName,
  LifestyleNanoID,
  LifestyleNda,
  LifestylePremiumContentAt,
  LifestyleRenderTypeID,
  LifestyleRenderTypeName,
  LifestyleUUID
} from '../lifestylesTypes';

export interface CacheFetchLifestylesQueryResponse {
  author: {
    id: LifestyleAuthorID;
    localizedName: LifestyleAuthorLocalizedName;
  };
  blocked: LifestyleBlocked;
  favorite: LifestyleFavorite;
  id: LifestyleID;
  uuid: LifestyleUUID;
  nanoId: LifestyleNanoID;
  name: LifestyleName;
  nda: LifestyleNda;
  createdAt: LifestyleCreatedAt;
  updatedAt: LifestyleCreatedAt;
  premiumContentAt: LifestylePremiumContentAt | null;
  maxFile: {
    createdAt: LifestyleCreatedAt;
  };
  renderTypes: {
    id: LifestyleRenderTypeID;
    name: LifestyleRenderTypeName;
  }[];
  image: {
    uuid: LifestyleImageUUID;
    id: LifestyleImageID;
    file: LifestyleImageFile;
  };
  category: {
    uuid: LifestyleCategoryUUID;
    name: LifestyleCategoryName;
    localizedName: LifestyleCategoryLocalizedName;
  };
}

export const CACHE_FETCH_LIFESTYLES_QUERY = gql`
  query CacheLifestyles(
    $filters: LifestylesFilters
    $sort: [LifestylesSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    lifestyles(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        author {
          id
          localizedName
        }
        blocked
        favorite
        id
        uuid
        name
        nanoId
        nda
        createdAt
        updatedAt
        premiumContentAt
        maxFile {
          createdAt
        }
        renderTypes {
          id
          name
        }
        image {
          uuid
          id
          file
        }
        category {
          uuid
          name
          localizedName
        }
      }
      paginationInfo {
        currentPage
        nextPage
        totalCount
      }
      sql
    }
  }
`;
